import { useDesignMaxTheme } from "@/packages";
import { useBookingRecoilValue } from "@/shared/client";
import { FONT } from "@/styles";
import { Box, Center, chakra, Flex, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

export const CTASection = ({ imgUrl }: { imgUrl: string }) => {
    const { ref, inView } = useInView({ threshold: 0.9, triggerOnce: true, delay: 0.3 });
    const { MEDIAS } = useDesignMaxTheme();
    const bookingURL = useBookingRecoilValue();

    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };
    const { isMobile } = MEDIAS();

    return (
        <Center
            ref={ref}
            w="100%"
            position="relative"
            background="#fbf6f2"
            pb={isMobile ? "56px" : "120px"}
            flexDir="column"
        >
            <Box
                position="absolute"
                top="0"
                w="100%"
                h={isMobile ? "234px !important" : "638px !important"}
                zIndex="2"
                borderTopLeftRadius={isMobile ? "40px" : "80px"}
                borderBottomRightRadius={isMobile ? "40px" : "80px"}
                background="#fff"
            />
            <Center
                maxW="952px"
                w="100%"
                p={isMobile ? "56px 24px 0 24px" : "120px 24px 0 24px"}
                zIndex="2"
                flexDir="column"
                rowGap={isMobile ? "16px" : "32px"}
            >
                <Box
                    textAlign="center"
                    sx={{
                        "& p": {
                            color: "#664628",
                        },
                    }}
                >
                    <Text {...FONT("notoSerif", isMobile ? 14 : 24, 400, 1.4)}>OUR PENSION</Text>
                    <Text {...FONT("notoSerif", isMobile ? 20 : 40, 600, 1.4)}>OF OLD MEMORIES</Text>
                </Box>
                <Flex w="100%" flexDir="column" rowGap={isMobile ? "16px" : "24px"}>
                    <MotionImageBox
                        w="100%"
                        h={isMobile ? "256px" : "620px"}
                        background={`url(${imgUrl})no-repeat center/cover`}
                        animate={{
                            // eslint-disable-next-line no-nested-ternary
                            borderTopRightRadius: inView ? (isMobile ? "40px" : "88px") : "0px",
                            // eslint-disable-next-line no-nested-ternary
                            borderBottomLeftRadius: inView ? (isMobile ? "40px" : "88px") : "0px",
                            transition: { duration: 1, ease: "easeInOut" },
                        }}
                    />
                    <Flex
                        w="100%"
                        pl="24px"
                        justifyContent={isMobile ? "flex-end" : "space-between"}
                        alignItems="flex-end"
                    >
                        <Box
                            display={isMobile ? "none" : "block"}
                            sx={{
                                "& p": {
                                    color: "#a8a8a8",
                                },
                            }}
                        >
                            <Text {...FONT("notoSerif", isMobile ? 14 : 16, 300)}>
                                {`Don't wait up. Don't be shy about liking and loving someone.`}
                            </Text>
                            <Text {...FONT("notoSerif", isMobile ? 14 : 16, 300)}>
                                Rather than living with an empty heart, love someone full of heart.
                            </Text>
                        </Box>
                        <Flex columnGap="11px" cursor="pointer" onClick={() => onLink(bookingURL)}>
                            <Text>Reservation</Text>
                            <Box
                                w="20px"
                                h="20px"
                                borderRadius="10px"
                                background="black"
                                color="#fff"
                                textAlign="center"
                            >{`>`}</Box>
                        </Flex>
                    </Flex>
                </Flex>
            </Center>
        </Center>
    );
};

const MotionImageBox = chakra(motion.div);
